var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    transform: "translate(24) scale(-1 1)",
    fill: "white",
    stroke: "#F58120"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.664 2.16V11.184H3.168V2.16H0V0H8.832V2.16H5.664Z",
    transform: "translate(8.00391 6)",
    fill: "#F58120"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/task-icon.5dcad95388d509b7b72ff22893c95793.svg";
export { ForwardRef as ReactComponent };